import { hexToRgba } from "../../../utils/FunctionsGlobals";

/* eslint-disable import/no-anonymous-default-export */
export interface ISearchTypes {
    label: string;
    options: Array<{ label: string; value: string; type: string }>;
}

export interface ISearchCode {
    label: string;
    value: string;
    type: string;
}

export const SearchCity: Array<ISearchCode> = [
    { label: 'Campina Grande', value: '1', type: 'city' },
    { label: 'João Pessoa', value: '2', type: 'city' },
    { label: 'Patos', value: '3', type: 'city' },
    { label: 'São Paulo', value: '4', type: 'city' },
    { label: 'Minas Gerais', value: '5', type: 'city' },
    { label: 'Novo Hamburgo', value: '6', type: 'city' },
    { label: 'Campo Bom', value: '7', type: 'city' },
];

export const SearchDistrict: Array<ISearchCode> = [
    { label: 'Campos', value: '1', type: 'district' },
    { label: 'Centro', value: '2', type: 'district' },
    { label: 'Jardins', value: '3', type: 'district' },
    { label: 'Flores', value: '4', type: 'district' },
    { label: 'Portal', value: '5', type: 'district' },
];

export const SearchType: Array<ISearchCode> = [
    { label: 'Apartamento', value: '1', type: 'type' },
    { label: 'Casa', value: '2', type: 'type' },
    { label: 'Casa em Condomínio', value: '3', type: 'type' },
    { label: 'Cobertura', value: '4', type: 'type' },
    { label: 'Terreno', value: '5', type: 'type' },
];

export const SearchCode: Array<ISearchCode> = [
    { label: '36', value: '36', type: 'code' },
    { label: '45', value: '45', type: 'code' },
    { label: '65', value: '65', type: 'code' },
    { label: '110', value: '110', type: 'code' },
    { label: '115', value: '115', type: 'code' },
    { label: '135', value: '135', type: 'code' },
];

const customSelectStyles = (color: string, colorArrow?: string) => {
    return {
        control: (base: any) => ({
            ...base,
            background: 'transparent',
            boxShadow: 'none',
            border: 0,
        }),
        dropdownIndicator: (base: any) => ({
            ...base,
            color: colorArrow || 'white',
        }),
        placeholder: (base: any) => ({
            ...base,
            color: 'white',
        }),
        singleValue: (base: any) => ({
            ...base,
            color: 'white',
        }),
        input: (base: any) => ({
            ...base,
            color: 'white',
        }),
        indicatorSeparator: (base: any) => ({
            ...base,
            backgroundColor: colorArrow || 'transparent',
        }),
    };
};

export const customSelectPropertiesStyles = (
    color: string,
    cor_fundo: string,
    select: string,
    colorArrow?: string,
    ordenar?: Boolean
) => {
    return {
        control: (base: any) => ({
            ...base,
            background: 'transparent',
            boxShadow: 'none',
            border: ordenar ? `1px solid ${color} !important` : `2px solid ${color} !important`,
            minHeight: 40,
            cursor: 'pointer',
            ':hover': {boxShadow: `0 1px 8px 0 ${hexToRgba(color, 0.3)};`}
        }),
        dropdownIndicator: (base: any) => ({
            ...base,
            color: colorArrow || 'white',
        }),
        placeholder: (base: any) => ({
            ...base,
            color: ordenar ? color : 'grey',
            fontWeight: 'bold',
            fontSize: 15,
        }),
        container: (base: any) => ({
            ...base,
            color: color || 'white',
        }),
        singleValue: (base: any) => ({
            ...base,
            color: 'grey',
            fontWeight: 'bold',
            fontSize: 14,
        }),
        indicatorSeparator: (base: any) => ({
            ...base,
            backgroundColor: color || 'white',
            background: color || 'white',
            color: color || 'white',
        }),
         menu: (base: any) => ({
            ...base,
            backgroundColor: cor_fundo || "white",
            color: color,
            zIndex: 10000,          // maior que o header/menu
        }),
        option: (base: any, state: any) => ({
            ...base,
            backgroundColor: state.isSelected
            ? select                    // selecionado
            : state.isFocused
            ? select                    // hover
            : cor_fundo,                   // normal
            color: state.isSelected && select != "#FFFFFFF"
            ? "#FFFFFF"                    // selecionado
            : state.isFocused && select != "#FFFFFFF"
            ? "#FFFFFF"                      // hover
            : color, 
            cursor: 'pointer',
            ':active': { backgroundColor: cor_fundo },
        }),
    };
};

export default {
    customSelectStyles,
    customSelectPropertiesStyles,
};
